/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteEntity
 */
export interface DeleteEntity {
    /**
     * 
     * @type {string}
     * @memberof DeleteEntity
     */
    id?: string;
}

/**
 * Check if a given object implements the DeleteEntity interface.
 */
export function instanceOfDeleteEntity(value: object): value is DeleteEntity {
    return true;
}

export function DeleteEntityFromJSON(json: any): DeleteEntity {
    return DeleteEntityFromJSONTyped(json, false);
}

export function DeleteEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function DeleteEntityToJSON(value?: DeleteEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

